import React from 'react';
import ReactDOM from 'react-dom/client';

function Item(props) {
    const post = props.post;
    return (
        <div className="" key={post.id}>
            <a href={"/post/" + post.slug} className="block mb-[14px]">
                <img src={post.image} alt={post.title}
                     className="w-full h-[300px] object-cover"/>
            </a>
            <a href={"/post/" + post.slug}
               className="lg:text-2xl text-xl font-bold text-dark-second block mb-2 leading-7">{post.title}</a>
            <p className="font-normal text-gray-main lg:leading-6 leading-5">{post.excerpt}</p>
        </div>);
}

export class LoadMoreBlog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            posts: [],
            page: 2,
            showLoadMore: true,
        }

        this.btn = document.getElementById('load_more_btn');
        this.btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.loadMore();
        });
    }

    loadMore() {
        fetch('/blog/load-more?page=' + this.state.page)
            .then(response => response.json())
            .then(data => {
                this.setState(({posts, page}) => ({
                    posts: posts.concat(data.posts),
                    page: data.next_page_url !== null ? page + 1 : page
                }));

                if (data.next_page_url === null) {
                    this.btn.style.display = 'none';
                }
            })
    }

    render() {
        return <div className="grid sm:grid-cols-2 gap-x-[30px] gap-y-9 font-inter mt-9">
            {this.state.posts.length > 0 && this.state.posts.map((post, index) =>
                <Item key={index} post={post}/>
            )}
        </div>;
    }

}

const section = document.getElementById('load_more_blog');
if (section) {
    const root = ReactDOM.createRoot(document.getElementById('load_more_blog'));
    root.render(<LoadMoreBlog/>);
}
